// extracted by mini-css-extract-plugin
export default {"container":"Panel_container__EUwDn","content":"Panel_content__F-bH1","action":"Panel_action__BZL1o"};